import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 
// getAnalytics-ah import pannikonga (measurementId irukathala safe-ku)
import { getAnalytics, isSupported } from "firebase/analytics"; 

const firebaseConfig = {
  apiKey: "AIzaSyBP707DbTpBSTvuz9AGmv6-NKpq4bnyOCQ",
  authDomain: "avaami.in",
  projectId: "avaami-odoo",
  storageBucket: "avaami-odoo.firebasestorage.app",
  messagingSenderId: "663892689266",
  appId: "1:663892689266:web:7138ca0d47d2b5ee6c5deb",
  measurementId: "G-P495H3RFPY"
};

// 1. Firebase App-ah initialize panrom
const app = initializeApp(firebaseConfig);

// 2. Analytics initialize panrom (if supported in environment)
// Ithu antha feature_collector warning-ah correct-ah stop panniidum
isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});

export const auth = getAuth(app);

// 3. Persistence setting
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Firebase Persistence Set to Local");
  })
  .catch((error) => {
    console.error("Firebase Persistence Error:", error);
  });

export const db = getFirestore(app);
export const storage = getStorage(app); 
export const googleProvider = new GoogleAuthProvider();

// Safe-ku Google Provider-la setup clear-ah iruka custom parameters add pannikalam
googleProvider.setCustomParameters({
  prompt: 'select_account' // User eppo click pannalum account choose panra option kaatum
});

export default app;